import { toast } from 'sonner';

const sendToast = ({ message, type = 'info', duration = 3000, infinite = false, action, id, style }) => {
  const options = {
    duration: infinite ? Infinity : duration,
    dismissible: true,
    id: id || undefined,
    action: action || undefined,
    style: style || undefined
  };

  switch (type) {
    case 'success':
      return toast.success(message, options);
    case 'error':
      return toast.error(message, options);
    case 'warning':
      return toast.warning(message, options);
    default:
      return toast.info(message, options);
  }
};

export default sendToast;
